import { t } from "@lingui/macro";
import { message } from 'antd';
import { deleto, get, patch, post, puto } from 'bukku/shared/ApiService';
import { all, call, fork, put, takeEvery } from 'bukku/shared/SagaService';
import AppActions from '../App/actions';
import { BankFeedDummyDatas } from '../BankFeed/dummy/BankFeedDummyDatas';
import { BankFeedUseDummy } from '../BankFeed/dummy/BankFeedUseDummy';
import actions from './actions';
import { BankAccountsWithBankFeeds } from './dummy/BankAccountsWithBankFeed';

// Read accounts
export function* readBankAccountsRequest() {
    yield takeEvery(actions.READ_BANK_ACCOUNTS_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/banking/accounts', request, context);
            const data = yield response.data;

            if (BankFeedUseDummy.BANK_ACCOUNTS_WITH_BANK_FEED)
                data.accounts = [...BankAccountsWithBankFeeds, ...data.accounts];

            // OK
            yield put({
                type: actions.READ_BANK_ACCOUNTS_SUCCESS,
                accounts: data.accounts,
                // accounts: MBB_BANK_ACCOUNTS,
                // accounts: [...MBB_BANK_ACCOUNTS, ...data.accounts],
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_BANK_ACCOUNTS_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readBankAccountsSuccess() {
    yield takeEvery(actions.READ_BANK_ACCOUNTS_SUCCESS, () => {});
}
export function* readBankAccountsError() {
    yield takeEvery(actions.READ_BANK_ACCOUNTS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read account
export function* readBankAccountRequest() {
    yield takeEvery(actions.READ_BANK_ACCOUNT_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/banking/accounts/${id}`, null, context);
            const data = yield response.data;

            if (BankFeedUseDummy.BANK_ACCOUNT_WITH_CONNECTION)
                data.account = BankFeedDummyDatas.BANK_ACCOUNT_WITH_CONNECTION;

            // OK
            yield put({
                type: actions.READ_BANK_ACCOUNT_SUCCESS,
                account: data.account,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_BANK_ACCOUNT_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readBankAccountSuccess() {
    yield takeEvery(actions.READ_BANK_ACCOUNT_SUCCESS, () => {});
}
export function* readBankAccountError() {
    yield takeEvery('READ_BANK_ACCOUNT_ERROR', function* ({ error }) {
        yield message.error(error.message);
    });
}

// Create account
export function* createBankAccountRequest() {
    yield takeEvery(actions.CREATE_BANK_ACCOUNT_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/banking/accounts', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.CREATE_BANK_ACCOUNT_SUCCESS,
                account: data.account,
            });
        }
        catch (error) {
            yield put({
                type: actions.CREATE_BANK_ACCOUNT_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createBankAccountSuccess() {
    yield takeEvery(actions.CREATE_BANK_ACCOUNT_SUCCESS, function* () {
        yield message.success(t`Bank account was created.`);
    });
}
export function* createBankAccountError() {
    yield takeEvery(actions.CREATE_BANK_ACCOUNT_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update account
export function* updateBankAccountRequest() {
    yield takeEvery(actions.UPDATE_BANK_ACCOUNT_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(puto, `/banking/accounts/${id}`, request, context);

            // OK
            yield put({
                type: actions.UPDATE_BANK_ACCOUNT_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.UPDATE_BANK_ACCOUNT_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateBankAccountSuccess() {
    yield takeEvery(actions.UPDATE_BANK_ACCOUNT_SUCCESS, function* () {
        yield message.success(t`Bank account was updated.`);
    });
}
export function* updateBankAccountError() {
    yield takeEvery(actions.UPDATE_BANK_ACCOUNT_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Archive account
export function* archiveRequest() {
    yield takeEvery(actions.BANK_ACCOUNT_ARCHIVE_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(patch, `/banking/accounts/${id}`, request, context);

            yield put({
                type: actions.BANK_ACCOUNT_ARCHIVE_SUCCESS,
                request,
            });
        }
        catch (error) {
            yield put({
                type: actions.BANK_ACCOUNT_ARCHIVE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* archiveSuccess() {
    yield takeEvery(actions.BANK_ACCOUNT_ARCHIVE_SUCCESS, function* ({ request }) {
        yield message.success(
            request.is_archived ? t`Bank account is deactivated.` : t`Bank account is activated.`,
        );
    });
}
export function* archiveError() {
    yield takeEvery(actions.BANK_ACCOUNT_ARCHIVE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete account
export function* deleteRequest() {
    yield takeEvery(actions.BANK_ACCOUNT_DELETE_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(deleto, `/banking/accounts/${id}`, request, context);

            yield put({
                type: actions.BANK_ACCOUNT_DELETE_SUCCESS,
                request,
            });
        }
        catch (error) {
            yield put({
                type: actions.BANK_ACCOUNT_DELETE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteSuccess() {
    yield takeEvery(actions.BANK_ACCOUNT_DELETE_SUCCESS, function* () {
        yield message.success(t`Bank account is deleted.`);
    });
}
export function* deleteError() {
    yield takeEvery(actions.BANK_ACCOUNT_DELETE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(readBankAccountsRequest),
        fork(readBankAccountsSuccess),
        fork(readBankAccountsError),
        fork(readBankAccountRequest),
        fork(readBankAccountSuccess),
        fork(readBankAccountError),
        fork(createBankAccountRequest),
        fork(createBankAccountSuccess),
        fork(createBankAccountError),
        fork(updateBankAccountRequest),
        fork(updateBankAccountSuccess),
        fork(updateBankAccountError),
        fork(archiveRequest),
        fork(archiveSuccess),
        fork(archiveError),
        fork(deleteRequest),
        fork(deleteSuccess),
        fork(deleteError),
    ]);
}
